import { blogProduct } from '@/types'
import {
  RegionImage,
  Tile,
  Wrapper,
  DesktopContainedSwiper,
  SwiperButtons,
  SwiperHeadingContainer,
  SwiperLeft,
  SwiperRight,
} from './Tiles.styles'
import { useRouter } from 'next/router'
import { useContext } from 'react'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { DefaultPropertiesContext } from '@/context/DefaultPropertiesContext'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

type TileProps = {
  blogPages: blogProduct[]
}

const BlogTiles = ({ blogPages }: TileProps) => {
  const router = useRouter()
  const { lang } = router.query
  const defaultProperties = useContext(DefaultPropertiesContext)
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)

  return (
    <>
      {blogPages && (
        <Wrapper data-mcp-id="blog-tiles">
          <SwiperHeadingContainer>
            <Heading size="XL">Inspire your next trip</Heading>
            <SwiperButtons>
              <SwiperLeft className="prev"></SwiperLeft>
              <SwiperRight className="next"></SwiperRight>
            </SwiperButtons>
          </SwiperHeadingContainer>
          <Spacing size="XL" />
          <DesktopContainedSwiper>
            <Swiper
              modules={[Navigation]}
              navigation={{ prevEl: '.prev', nextEl: '.next' }}
              breakpoints={{
                0: {
                  spaceBetween: 16,
                  slidesPerView: 'auto',
                  loop: false,
                },
                768: {
                  spaceBetween: 16,
                  slidesPerView: 2,
                  loop: false,
                },
                1100: {
                  spaceBetween: 24,
                  slidesPerView: 3,
                  loop: false,
                },
              }}
            >
              {blogPages?.map(({ title, link, image }) => (
                <SwiperSlide key={link}>
                  <Tile href={`${baseUrl}/${lang}/${link}`} fullWidth>
                    <RegionImage
                      style={{
                        backgroundImage: `url(${image})`,
                      }}
                    />
                    <Heading size="S" bold={false} spacing={false}>
                      {title}
                    </Heading>
                  </Tile>
                </SwiperSlide>
              ))}
            </Swiper>
          </DesktopContainedSwiper>
        </Wrapper>
      )}
    </>
  )
}

export default BlogTiles
